import type { ComponentProps, PropsWithChildren } from 'react'
import { RecommendCard, RestaurantRecommendCard } from '~/components/ScrollableRestaurants'
import { getFragmentData } from '~/lib/graphql'
import type { RestaurantId } from '~/lib/graphql/scalars'
import type { HistoryState } from '~/navigation'
import { hstack } from '~/styled-system/patterns'

type BottomRestaurantsProps = {
  restaurants: ComponentProps<typeof RecommendCard>['restaurant'][]
  linkTo: (restaurantId: RestaurantId) => string
  state?: HistoryState
}

export function BottomRestaurants({
  restaurants,
  linkTo,
  state,
  children,
}: PropsWithChildren<BottomRestaurantsProps>) {
  return (
    <div
      className={hstack({
        alignItems: 'stretch',
        gap: '4',
        w: 'full',
        overflow: 'visible',
        px: '0',
      })}
      data-nosnippet
    >
      {restaurants.map((data) => {
        const restaurantId = getFragmentData(RestaurantRecommendCard, data).restaurantId
        return (
          <RecommendCard
            restaurant={data}
            key={restaurantId}
            linkTo={linkTo}
            state={state}
            spread
          />
        )
      })}
      {children && <div className="grid content-center">{children}</div>}
    </div>
  )
}
